import { CalendarMonth, Money, Paid, People } from "@mui/icons-material";
import { Backdrop, Box, Card, CircularProgress, Container, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { PartnerService } from "../services/PartnerService";
import { WebStorageService } from "../services/WebStorageService";
import { CURRENT_USER } from "../contants/constants";
import { CurrentUser } from "../models/CurrentUser";
import { Dashboard } from "../models/Dashboard";
import { Order } from "../models/Order";
import { Utils } from "../helpers/utils";

export default function MyDashboard() {
    const webStorageService = new WebStorageService();
    const partnerService:PartnerService = new PartnerService();
    const [user, setUser] = useState<CurrentUser>(webStorageService.getJson(CURRENT_USER));
    const [dashboard, setDashboard] = useState(new Dashboard());
    const [isValidating, setIsValidating] = useState(false);

    const [recentOrders, setRecentOrders] = useState([
        createOrder(10001, 'Daryl Gomez', new Date().toLocaleDateString(), "Regasco", 4.0),
        createOrder(10002, 'Alyza Zenon', new Date().toLocaleDateString(), "Phinoy", 4.3),
        createOrder(10003, 'Marian Rivera', new Date().toLocaleDateString(), "Shine 2.7", 6.0),
        createOrder(10004, 'Marilou Novida', new Date().toLocaleDateString(), "Petron Gasul", 4.3),
        createOrder(10005, 'Rachelle Arellano', new Date().toLocaleDateString(), "Superkalan", 3.9),
    ]);

    useEffect(() => {
        setIsValidating(true);
        partnerService.GetDashboard(Number(user.ID)).then(response => {
            if(response.Data != undefined)
                setDashboard(response.Data);
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            setIsValidating(false);
        });
    }, []);


    function createOrder(orderID: number, fullName: string, createdDate: string, product: string, total: number) {
        return { OrderID:orderID, FullName: fullName, CreatedDate: createdDate, Product: product, Total: total };
    }

    return (
        <Container sx={{ flexDirection: "column", paddingTop: 15 }}>
            <Backdrop open={isValidating} sx={{ zIndex: 100000 }}>
                <CircularProgress color="error"></CircularProgress>
            </Backdrop>
            <Typography variant="h5" sx={{marginBottom:2}}>Dashboard</Typography>
            <Box sx={{ display: {xs:"block", sm:"block", md:"flex", lg:"flex"}, justifyContent: "space-between"}}>
                <Paper sx={{marginBottom:2, backgroundColor: "#f5e7e7"}}>
                    <Box sx={{ display: "d-flex", justifyContent: "space-between", width: 250, padding: 1 }}>
                        <Box sx={{ width: 100, textAlign: "center" }}>
                            <People sx={{ fontSize: 50 }} color="primary"></People>
                        </Box>
                        <Box sx={{ width: 150, textAlign: "center" }}>
                            <Typography variant="h4">{Utils.formatNumberWithoutDecimal(dashboard.TotalReferrals)}</Typography>
                            <Typography variant="subtitle2" color="grey">Referrals Count</Typography>
                        </Box>
                    </Box>
                </Paper>

                <Paper sx={{marginBottom:2, backgroundColor: "#f5e7e7"}}>
                    <Box sx={{ display: "d-flex", justifyContent: "space-between", width: 250, padding: 1 }}>
                        <Box sx={{ width: 100, textAlign: "center" }}>
                            <Money sx={{ fontSize: 50 }} color="primary"></Money>
                        </Box>
                        <Box sx={{ width: 150, textAlign: "center" }}>
                            <Typography variant="h4">{Utils.formatNumberWithoutDecimal(dashboard.ThisMonthEarnings)}</Typography>
                            <Typography variant="subtitle2" color="grey">This Month Earnings</Typography>
                        </Box>
                    </Box>
                </Paper>

                <Paper sx={{marginBottom:2, backgroundColor: "#f5e7e7"}}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", width: 250, padding: 1 }}>
                        <Box sx={ { width: 100, textAlign: "center" }} >
                            <Paid sx={{ fontSize: 50 }} color="primary"></Paid>
                        </Box>
                        <Box sx={{ width: 150, textAlign: "center" }}>
                            <Typography variant="h4">{Utils.formatNumberWithoutDecimal(dashboard.TotalEarnings)}</Typography>
                            <Typography variant="subtitle2" color="grey">Total Payout</Typography>
                        </Box>
                    </Box>
                </Paper>
            </Box>

            <TableContainer component={Paper} sx={{marginBottom:2, backgroundColor: "#f5e7e7"}}>
                <Typography variant="h5" textAlign="center" sx={{marginY:2}}>Recent Referred Orders</Typography>
                <Divider></Divider>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow sx={{}}>
                            <TableCell align="center" sx={{ fontWeight:"bold", display:{xs:"none", sm:"block"}}}>Order ID</TableCell>
                            <TableCell align="center" sx={{ fontWeight:"bold"}}>Date</TableCell>
                            <TableCell align="center" sx={{ fontWeight:"bold"}}>Customer</TableCell>
                            <TableCell align="right" sx={{ fontWeight:"bold"}}>Earned</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dashboard.ReferredOrders.map((row) => (
                            <TableRow>
                                <TableCell align="center" sx={{display:{xs:"none", sm:"block"}}}>{row.SalesOrderID}</TableCell>
                                <TableCell align="center">{Utils.toMMDDYYYY(row.CreatedDate)}</TableCell>
                                <TableCell align="center">{row.CustomerName}</TableCell>
                                <TableCell align="right">{Utils.formatNumber(row.Earned)}</TableCell>
                                
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer component={Paper} sx={{marginBottom:2, backgroundColor: "#f5e7e7"}}>
                <Typography variant="h5" textAlign="center" sx={{marginY:2}}>Recent Payout History</Typography>
                <Divider></Divider>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ fontWeight:"bold", display:{xs:"none", sm:"block"} }}>Payout ID</TableCell>
                            <TableCell align="center" sx={{ fontWeight:"bold" }}>Date</TableCell>
                            <TableCell align="center" sx={{ fontWeight:"bold" }}>Payment Reference</TableCell>
                            <TableCell align="center" sx={{ fontWeight:"bold", display:{xs:"none", sm:"block"} }}>Payment Gateway</TableCell>
                            <TableCell align="right" sx={{ fontWeight:"bold" }}>Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dashboard.Payouts.map((row) => (
                            <TableRow key={row.PayoutID}>
                                <TableCell align="center" sx={{display:{xs:"none", sm:"block"}}}>{row.PayoutID}</TableCell>
                                <TableCell align="center">{Utils.toMMDDYYYY(row.CreatedDate)}</TableCell>
                                <TableCell align="center">{row.PayoutReferenceNo}</TableCell>
                                <TableCell align="center" sx={{display:{xs:"none", sm:"block"}}}>{row.PaymentGateway}</TableCell>
                                <TableCell align="right" component="th" scope="row">{Utils.formatNumber(row.Total)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
}